<div class="svg-loader" *ngIf="isLoading"></div>
<div class="largeModelContainer" *ngIf="!isLoading">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter ">
    Flowsheet Specification - {{componentDetails.componentUniqueId}}
  </div>
  <div class="modelBody">
    <form #connectorSpecificationForm="ngForm">
      <div class="pl-4 pr-4" [ngClass]="{'readOnly' : readOnly}">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12">
            <div class="row mb-2">
              <div class="col-sm-12 row">
              </div>
              <div class="col-sm-12 row">
                <div class="parameterContainer">
                  <label class="parameterName" for="selectedFlowsheet">
                    <strong>Flowsheet Name</strong>
                    <span class="text-danger star-danger">*</span>
                  </label>
                  <div class="parameterOption">
                    <select class="custom-select form-control" id="selectedFlowsheet"
                            [(ngModel)]="selectedFlowsheet"
                            name="selectedFlowsheet" [disabled]="readOnly">
                      <option *ngFor="let item of flowsheetsListDetails" [ngValue]="item">{{item.flowSheetName}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="saveBtn2 actionBtn" [disabled]="!selectedFlowsheet || readOnly" (click)="saveFlowsheetDetails()">
          Save
        </button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

